<template>
  <div v-if="updateExists" class="update-notification">
    <p>E' disponibile una nuova versione.</p>
    <button @click="refreshApp">Aggiorna</button>
  </div>
</template>

<script>
export default {
  name: 'AppUpdateNotification',
  data() {
    return {
      registration: null,
      updateExists: false,
    };
  },
  created() {
    document.addEventListener('swUpdated', this.onSWUpdated, { once: true });
  },
  methods: {
    onSWUpdated(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      // Make sure we have a registration to work with
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      // Send a message to the waiting service worker to activate itself
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // Reload the page to use the new service worker
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.update-notification {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #333;
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 15px;
}
</style>